export default __webpack_public_path__ + "static/media/twitter-x.4060146f.png";